import { useEffect, useMemo } from 'react';

import { DatabaseOnboardingService } from '../services/database-onboarding-service.ts';

export const useOnboardingService = ({ service }: { service?: DatabaseOnboardingService } = {}) => {
	const onboardingService = useMemo(
		() => (service === undefined ? new DatabaseOnboardingService() : service),
		[service],
	);

	useEffect(() => {
		return () => {
			onboardingService.dispose();
		};
	}, [onboardingService]);

	return onboardingService;
};
